import {FC, useState} from "react";
import { DeviceRow } from "entities/devices/model/types";
import {
    DeviceMobileItemDisable,
    DeviceMobileItemHive,
    DeviceMobileItemTitle, DeviceMobileItemUpdated, DeviceMobileItemVoltage,
    DeviceRemoveContent, DeviceRemoveContentColButtons,
    DeviceRemoveContentColF,
    DevicesMobileItem,
    DevicesMobileWrapper,
    DevicesEmptyState,
    DevicesEmptyStateTitle,
} from "./styles";
import { BatteryBadge } from "../components/BatteryBadge";
import { DisableButton } from "../components/DisableButton";
import Modal from "@atomaro/ui-kit/components/Modal/Modal";
import {Button} from "@atomaro/ui-kit";
import {useDevicesStore} from "entities/devices";
import {toast} from "react-toastify";
import {formatDistanceToNowStrict} from "date-fns";
import {ru} from "date-fns/locale";
import HiveCol from "features/devices/ui/components/HiveCol.tsx";
import { AddLarge } from "shared/ui/icons/addLarge";

type Props = { rows: DeviceRow[]; onOpenModal: () => void };

export const DevicesMobile: FC<Props> = ({ rows, onOpenModal }) => {
    const detachDevice = useDevicesStore(s => s.detachDevice);
    const [isOpenRemoveModal, setIsOpenRemoveModal] = useState<string>("");

    const onConfirmDetach = async () => {
        const id = isOpenRemoveModal;
        if (!id) return;
        try {
            await detachDevice(id);
            toast.success("Устройство отключено");
            setIsOpenRemoveModal("");
        } catch {
            toast.error("Не удалось отключить устройство");
        }
    };

    return (
    <>
        <DevicesMobileWrapper>
            {rows.length ? rows.map((el) => (
                <DevicesMobileItem key={el.id}>
                    <DeviceMobileItemTitle>
                        {el.name || "Устройство без названия"}
                    </DeviceMobileItemTitle>
                    <DeviceMobileItemVoltage>
                        <BatteryBadge voltage={el.batteryVoltage}/>
                    </DeviceMobileItemVoltage>
                    <DeviceMobileItemUpdated>
                        {el.updatedAt ? formatDistanceToNowStrict(new Date(el.updatedAt), { locale: ru, addSuffix: true }) : ""}
                    </DeviceMobileItemUpdated>
                    <DeviceMobileItemHive>
                        <HiveCol name={el.hiveTitle} id={el.hiveId || ""}/>
                    </DeviceMobileItemHive>
                    <DeviceMobileItemDisable>
                        <DisableButton id={el.id} openModal={() => setIsOpenRemoveModal(el.id)}/>
                    </DeviceMobileItemDisable>
                </DevicesMobileItem>
            )) : (
                <DevicesEmptyState>
                    <DevicesEmptyStateTitle>Добавьте устройство</DevicesEmptyStateTitle>
                    <Button
                        size="m"
                        colorScheme="accent"
                        label="Добавить устройство"
                        iconPrefix={<AddLarge fill="white" />}
                        onClick={onOpenModal}
                    />
                </DevicesEmptyState>
            )}
        </DevicesMobileWrapper>


        <Modal
            isOpen={!!isOpenRemoveModal}
            centered
            style={{padding: 0, maxHeight: '100%', width: "90%", maxWidth: "450px"}}
            onClickOverlay={() => setIsOpenRemoveModal("")}
        >
            <DeviceRemoveContent>
                <DeviceRemoveContentColF>
                    <h3>Вы уверены что хотите отключить устройство?</h3>
                    <svg onClick={() => setIsOpenRemoveModal("")} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="24.000000" height="24.000000" fill="none">
                        <rect id="24 / Navigation / Close Large" width="24.000000" height="24.000000" x="0.000000" y="0.000000" />
                        <path id="Union" d="M10.9401 12.0006L4.99902 17.9417L6.05968 19.0023L12.0008 13.0612L17.9418 19.0023L19.0025 17.9417L13.0614 12.0006L19.0025 6.0595L17.9418 4.99884L12.0008 10.9399L6.0597 4.99884L4.99904 6.0595L10.9401 12.0006Z" fill="rgb(16,24,40)" fillRule="evenodd" />
                    </svg>
                </DeviceRemoveContentColF>
                <DeviceRemoveContentColButtons>
                    <Button size="m" colorScheme="neutral" label="Отменить" onClick={() => setIsOpenRemoveModal("")} />
                    <Button size="m" colorScheme="accent" label="Отключить" onClick={onConfirmDetach} />
                </DeviceRemoveContentColButtons>
            </DeviceRemoveContent>
        </Modal>
    </>
    );
};
